import {Component, inject} from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {DxTabsComponent} from 'devextreme-angular';
import {ActivatedRoute} from '@angular/router';
import {map, shareReplay} from 'rxjs/operators';
import {distinctUntilChanged} from 'rxjs';
import {OrderDetailsComponent} from './order-details/order-details.component';
import {OrderHistoryComponent} from './order-history/order-history.component';

type TabKey = 'details' | 'history';

@Component({
    selector: 'app-order',
    standalone: true,
    imports: [AsyncPipe, DxTabsComponent, OrderDetailsComponent, OrderHistoryComponent],
    templateUrl: './order.component.html',
})
export class OrderComponent {
    private route = inject(ActivatedRoute);

    selectedTab: TabKey = 'details';

    readonly number$ = this.route.paramMap.pipe(
        map((params) => params.get('number')),
        distinctUntilChanged(),
        shareReplay(1),
    );

    tabs = [
        {key: 'details', text: 'Details', icon: 'fas fa-info-circle'},
        {key: 'history', text: 'History', icon: 'fas fa-history'},
    ];
}
